import { ButtonComponentActionConfigVariant, DropdownOption } from '@repo/sdk/models/components';

import { getRefValue } from '@/features/equipment-browser/utils';
import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';

import { ActionDropdownDisplay } from './action-dropdown-display';
import { ActionComponentProps } from './types';
import { useHandleUpdateSettings } from './use-handle-update-settings';

export const ActionDropdown = ({ state, disabled, ...buttonProps }: ActionComponentProps) => {
  const { isDisabled: disabledByPermissions, tooltipText: permissionTooltipText } =
    useActionPermission({
      // TODO: UX-3355: We probably need to specify permissions in the dropdown config
      privilege: PRIVILEGES.writeCommands,
    });

  const { handleUpdateSettings, isPending } = useHandleUpdateSettings();

  const dropdownConfig = state?.actionComponentConfig?.dropdownComponentActionConfig;

  const currentValue = dropdownConfig?.valueRef
    ? getRefValue(dropdownConfig.valueRef)?.toString()
    : undefined;

  const handleSelect = (option: DropdownOption) => {
    handleUpdateSettings(option.actions?.settingActions || []);
  };

  const disabledButton = isPending || dropdownConfig?.disabled || disabled;
  const disabledActions = disabledByPermissions;

  const buttonVariant = dropdownConfig?.buttonVariant ?? ButtonComponentActionConfigVariant.Default;

  const tooltipContent = dropdownConfig?.disabled
    ? 'The fault cannot be reset until system conditions are met.'
    : disabledByPermissions
      ? permissionTooltipText
      : undefined;

  return (
    <ActionDropdownDisplay
      {...buttonProps}
      buttonVariant={buttonVariant}
      disabled={disabledButton}
      disableItems={disabledActions}
      onSelect={handleSelect}
      options={dropdownConfig?.options ?? []}
      showIcon={dropdownConfig?.showIcon}
      stateName={state?.stateName}
      subtitle={dropdownConfig?.subtitle}
      tooltipContent={tooltipContent}
      value={currentValue}
    />
  );
};
